export default [
    // aspects 
{
  path: '/expertsgroup',
  name: 'Expertsgroup',
  props: true,
  component: () => import(/* webpackChunkName: "about" */ '../../../views/expertsgroup/expertsgroup.vue'),
  meta: { 
    requiresAuth: true
  }
},
]